import { render, staticRenderFns } from "./BaseTabs.vue?vue&type=template&id=5adef0d7&"
import script from "./BaseTabs.vue?vue&type=script&lang=ts&"
export * from "./BaseTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports